/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum PharmacyInfoContentLayoutEnum {
    SHORT = 'SHORT',
    EXPANDED = 'EXPANDED',
}